import { Form } from "antd";
import { HeaderOverview, IRenderPieChart, RenderPieChart } from "components";
import {
  ErrorDashboard,
  LoadingDashboard,
  NoDataDashboard,
  WrapperBG,
  checkDataObject,
} from "pages/overview";
import { useOverview } from "providers/overview";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useGetDashboardMostVehicle } from "service/dashboard/central/vehicle";

const COLORS = ["#F8931D", "#D2D3D5", "#276347"];

const VehicleTop = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();

  const vehicleTopDate = Form.useWatch("vehicleTopDate");
  const date = findDate(vehicleTopDate);

  const { data, isFetching, isError, error } = useGetDashboardMostVehicle({
    ...date,
    property,
  });


  const findData = useMemo(() => {
    const transformedData = checkDataObject(data);
    if (transformedData) {
      return Object.keys(transformedData).map(key => ({
        brand: key,
        count: transformedData[key],
      }));
    }
    return [];
  }, [data]);

  const dataPie = useMemo<IRenderPieChart>(
    () => ({
      data: findData,
      dataKey: "count",
      dataName: "brand",
      color: COLORS,
      text: " ",
      height: 250,
    }),
    [findData]
  );
  return (
    <WrapperBG>
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("the-3-most-popular-brands-vehicle-brands")}
          name="vehicleTopDate"
        />
        {isError ? (
          <ErrorDashboard error={error} height="250px" />
        ) : !findData || findData.length <= 0 ? (
          <NoDataDashboard height="250px" />
        ) : (
          <RenderPieChart {...dataPie} />
        )}
      </LoadingDashboard>
    </WrapperBG>
  );
};

export default VehicleTop;
